import { getApiEmployer } from "./api";

// P1 (Jun-2026) — echte Händler-Module, die ein Mitarbeiter (Vermittler) im
// Arbeitgeber-Kontext nutzen darf. `perm: null` = für jeden bestätigten
// Mitarbeiter (z. B. Intranet). Reihenfolge = Roll-out-Reihenfolge des Users.
export const EMPLOYER_MODULES = [
    { perm: "workshop", label: "Werkstatt", path: "/dealer/workshop-orders" },
    { perm: "wms", label: "Warenwirtschaft", path: "/dealer/wms" },
    { perm: "accounting", label: "Rechnungen", path: "/dealer/invoices" },
    { perm: "dispo", label: "Disposition", path: "/dealer/disposition" },
    { perm: "accounting", label: "Buchhaltung", path: "/dealer/buchhaltung" },
    { perm: null, label: "Intranet", path: "/intranet" },
];

export function employerPerms() {
    try {
        return JSON.parse(sessionStorage.getItem("tw_employer_perms") || "[]");
    } catch {
        return [];
    }
}

export function employerName() {
    return sessionStorage.getItem("tw_employer_name") || "";
}

// Speichert den Arbeitgeber-Kontext (Name + Rechte) für Banner/Navigation.
export function rememberEmployerContext(employer) {
    try {
        sessionStorage.setItem("tw_employer_name", employer?.dealer_name || "");
        sessionStorage.setItem("tw_employer_perms", JSON.stringify(employer?.permissions || []));
    } catch { /* noop */ }
}

export function clearEmployerContext() {
    try {
        sessionStorage.removeItem("tw_employer_name");
        sessionStorage.removeItem("tw_employer_perms");
    } catch { /* noop */ }
}

// Darf der aktuelle (Mitarbeiter-)User dieses Modul im Arbeitgeber-Kontext sehen?
export function employerAllows(user, requiredPerm) {
    if (!user) return false;
    // Jul-2026 (Bugfix): feste Mitarbeiter (zweiradverkaeufer) arbeiten immer im
    // Arbeitgeber-Kontext — Backend mappt & prüft. Sonst Redirect-Schleife zur Homeseite.
    if (user.role === "zweiradverkaeufer") return true;
    if (user.role !== "vermittler") return false;
    if (!getApiEmployer()) return false;
    if (requiredPerm == null) return true;
    return employerPerms().includes(requiredPerm);
}

// Liste der im aktuellen Kontext zugänglichen Module (für Schnellwechsler).
export function grantedEmployerModules() {
    const perms = employerPerms();
    return EMPLOYER_MODULES.filter((m) => m.perm == null || perms.includes(m.perm));
}
